import { render } from "./Recharge.vue?vue&type=template&id=667c5c8a&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=js"
export * from "./Recharge.vue?vue&type=script&lang=js"

import "./Recharge.vue?vue&type=style&index=0&id=667c5c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667c5c8a"]])

export default __exports__